@if (details) {
	<details class="cue-technical-details">
		<summary>Detalles técnicos para soporte</summary>
		<pre>{{ details }}</pre>
	</details>
}
